import OverviewRoute from 'cio/pods/base/overview/route';
export default OverviewRoute;
